import type { RefObject } from 'react';
import { createContext, useContext } from 'react';

/**
 * ネストされたテーブルのsticky設定を親テーブルから受け渡すためのコンテキスト
 *
 * 親テーブルのStickyTableWrapperが、自身のヘッダー下端位置（offsetHeader + headerHeight）を
 * 子テーブルに伝えることで、ネストされたテーブルのstickyヘッダーが正しい位置に配置される。
 * また、プロキシスクロール方式ではスクロールプロキシRefとコンテナRefを渡し、
 * ネストテーブルのピン留めセルのtransform更新に使用する。
 */
type NestedStickyContextValue = {
  /** ネストされたテーブルのstickyヘッダーのtop位置（px） */
  offsetHeader: number;
  /** ネストされたテーブルのstickyヘッダーのz-index */
  zIndex: number;
  /** 親テーブルのスクロールプロキシRef（ネストテーブルのピン留めセル更新用） */
  proxyRef: RefObject<HTMLDivElement | null>;
  /** 親テーブルのコンテナRef（ピン留めセルの位置計算でコンテナ幅の取得に使用） */
  containerRef: RefObject<HTMLDivElement | null>;
};

export const NestedStickyContext = createContext<NestedStickyContextValue | null>(null);

/**
 * 親テーブルからネストされたテーブル用のsticky設定を取得するフック
 */
export const useNestedStickyOffset = (): NestedStickyContextValue | null => {
  return useContext(NestedStickyContext);
};
